"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getRemainingCookieTimeMinutes = function (expirationDate) {
    var remainingTimeMillis = expirationDate.getTime() - Date.now();
    return remainingTimeMillis / 1000 / 60;
};
exports.default = getRemainingCookieTimeMinutes;
